import React from 'react';
import './index.css';
import { connect } from 'react-redux';
import { updateAlert } from '../../redux/actions';

function Footer({ handleAlert }) {

  const handleCopyEmail = () => {
    // Copy email to clipboard
    const email = "hulabapps@emory.edu";
    navigator.clipboard.writeText(email);
    handleAlert("success", "Email Copied!");
  }

  return (
    <div className="footer-content">
      Contact us at: <span className="contact-email" onClick={handleCopyEmail}>hulabapps@emory.edu</span>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    }
  };
}

export default connect(null, mapDispatchToProps)(Footer);